module.exports = "/_next/static/images/login@3x-95ba77266c2a168c2b48dc9aba6d8b09.png";